import { Icon } from "pepsico-ds";
import "./_sweepstakes-status-badge.scss";

const SweepstakesStatusBadge = ({ status, badgeClass }) => {
  const hasEnded = status.toLowerCase() === "ended";
  return (
    <div
      className={`status ${badgeClass?.toLowerCase() || ""}`}
      data-testid="sweepstakes-status-badge"
    >
      {!hasEnded
        ? status.charAt(0).toUpperCase() + status.slice(1)
        : "Winners Confirmed"}
      {hasEnded && <Icon icon="check" size="small" />}
    </div>
  );
};

export default SweepstakesStatusBadge;
